module.exports = __webpack_public_path__ + "static/img/2.ff7a494.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/1/2.png
// module id = +SgV
// module chunks = 1